export function getDefaultAccountCode(): string | undefined {
  return window.localStorage.getItem('default-account-code') ?? undefined;
}

export function setDefaultAccountCode(val: string) {
  window.localStorage.setItem('default-account-code', val);
}
